import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import WidgetSettings from "./widgetsettings"
import { selectionTypes } from 'src/components/utils/consts';
import { seconds2HMS } from 'src/components/utils/utils';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {
    DataGrid, Column, ColumnChooser, Paging, Sorting, SearchPanel, Scrolling
} from 'devextreme-react/data-grid';
import CallStatus from "./callstatus";
import DataSource from 'devextreme/data/data_source';
import ArrayStore from "devextreme/data/array_store";
import MonitorService from 'src/controllers/MonitorService';
import TransferButton from './transferbutton';

const TransferButtonRenderer = React.memo(({ data, userId, token }) => {
    return <TransferButton call={data} token={token} userId={userId} type="call" />;
});
const ChannelIconRenderer = React.memo(({ value }) => {
    return <CallStatus call={value} />;
});
class QueuedCalls extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showSettings: false,
            selectedGroups: [],
            queuedCalls: 0
        };

        this.updateState = this.updateState.bind(this);
        this.selectGroups = this.selectGroups.bind(this);
        this.toggleSettings = this.toggleSettings.bind(this);

        this.lastUpdate = new Date();
        this.lastUpdate.setMinutes(this.lastUpdate.getMinutes() - 1);
        this.dataGridRef = React.createRef();
        this.store = new ArrayStore({
            key: "id",
            data: []
        });


        this.dataSource = new DataSource({
            store: this.store,
            reshapeOnPush: true
        });

        this.renderTransferButton = (cellInfo) => (
            <TransferButtonRenderer
                key={cellInfo.data.guid}
                data={cellInfo.data}
                userId={this.props.userId}
                token={this.props.token}
            />
        );
        this.renderChannelIcon = (cellInfo) => (
            <ChannelIconRenderer key={cellInfo.data.guid} value={cellInfo.data} />
        );
    }

    toggleSettings() {
        this.setState({
            showSettings: !this.state.showSettings
        });
    }

    selectGroups(groups) {
        this.setState({
            groups: groups,
            showSettings: !this.state.showSettings
        });

        localStorage.setItem(`QueuedCalls_groups_${this.props.userId}`, JSON.stringify(groups));
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/subscribe/queuedcalls", {}, JSON.stringify({
                token: this.props.token,
                groupsIds: groups
            }));
        }

    }

    updateState(calls) {
        let lastUpdateDiff = (new Date() - this.lastUpdate);
        if (lastUpdateDiff > 1000) {
            var data = JSON.parse(calls.body);

            data.forEach(v => {
                var queueDate = new Date();
                queueDate.setSeconds(queueDate.getSeconds() - v.timeWaiting);
                queueDate.setMilliseconds(1);
                var diff = v.timeWaiting;
                v.queueDate = queueDate;

                v.waitingTime = seconds2HMS(diff);
            });

            let callIds = this.dataSource.items().map(x => x.id);
            const changes = [];
            callIds.forEach(x => {
                if (data.map(c => c.id).indexOf(x) === -1) {
                    changes.push({ type: 'remove', key: x });
                }

            });

            data.forEach(v => {
                if (callIds.indexOf(v.id) > -1) {
                    changes.push({ type: 'update', key: v.id, data: v });
                } else {
                    changes.push({ type: 'insert', data: v });
                }

            });

            if (changes.length)
                this.dataSource.store().push(changes);

            this.lastUpdate = new Date();

            this.setState({
                queuedChats: data.length
            });
        }
    }

    componentDidMount() {

        let selectedGroups = JSON.parse(localStorage.getItem(`QueuedCalls_groups_${this.props.userId}`) || "[]");
        this.setState({
            selectedGroups: selectedGroups,
        });
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/subscribe/queuedcalls", {}, JSON.stringify({
                token: this.props.token,
                groupsIds: selectedGroups
            }));

            MonitorService.stompClient.subscribe(`/user/${this.props.token}/topic/queuedcalls/`, this.updateState, { id: "queuedcalls" });
        }
    }

    componentWillUnmount() {

        if (this.dataSource?.dispose) {
            this.dataSource.dispose();
        }
        if (this.store?.clear) {
            this.store.clear();
        }
        if (this.dataGridRef.current && this.dataGridRef.current.instance) {
            this.dataGridRef.current.instance.dispose();
        }
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/unsubscribe/queuedcalls", {}, JSON.stringify({
                token: this.props.token,
            }));

            MonitorService.stompClient.unsubscribe("queuedcalls");
        }
    }

    render() {

        return (
            <div className='position-relative' style={{ top: 10 }}>
                <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} style={{ width: "100%", height: "100%", margin: "0px" }}>
                    <div className="card-header drag-handle">
                        <h3 className="card-title align-items-start flex-column text-primary">
                            <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("phone-plus")} /> {this.props.t("queuedcalls")} <span className="badge badge-light-primary fs-base">{this.state.queuedCalls}</span></span>
                        </h3>
                        <div className="card-toolbar" style={{ zIndex: 1000 }}>
                            <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("config")}
                                </Tooltip>}>
                                <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={this.toggleSettings} >
                                    <FontAwesomeIcon icon={duotone("grid-2")} />
                                </button>
                            </OverlayTrigger>
                        </div>
                    </div>
                    <div className="card-body" style={{ padding: "0px", height: "465px" }} >

                        <DataGrid
                            id="queuedcallstable"
                            ref={this.dataGridRef}
                            dataSource={this.dataSource}
                            showBorders={false}
                            repaintChangesOnly={true}
                            columnAutoWidth={true}
                            width={"100%"}
                            height={"99%"}
                            allowColumnResizing={true}
                            rowAlternationEnabled={true}
                            loadPanel={{ enabled: false }}
                        >
                            <SearchPanel
                                visible={true}
                                width={240}
                                placeholder={this.props.t("search")}
                            />
                            <Sorting mode={"single"} />
                            <Scrolling mode={"standard"} />
                            <Paging defaultPageSize={7} />
                            <Column dataField="id" visible={false} showInColumnChooser={false} />
                            <Column cssClass={"align-middle"} visible={this.props.functions.manageInteractions} dataField="transfer" caption={""} showInColumnChooser={false} width={60} cellRender={this.renderTransferButton} />
                            <Column cssClass={"align-middle text-center"} dataField="status" caption={this.props.t("status")} showInColumnChooser={true} width={50} cellRender={this.renderChannelIcon} />
                            <Column cssClass={"align-middle"} dataField="queueDate" caption={this.props.t("hour")} dataType={"datetime"} format={"HH:mm:ss"} visible={true} width={70} />
                            <Column cssClass={"align-middle"} dataField="caller" caption={this.props.t("caller")} visible={true} width={100} />
                            <Column cssClass={"align-middle"} dataField="called" caption={this.props.t("called")} visible={false} width={160} />
                            <Column cssClass={"align-middle"} dataField="calledName" caption={this.props.t("calledname")} visible={false} width={160} />
                            <Column cssClass={"align-middle"} dataField="groupName" caption={this.props.t("group")} visible={true} width={80} />
                            <Column cssClass={"align-middle"} dataField="waitingTime" caption={this.props.t("waitingtime")} visible={true} width={100} />
                            <Column cssClass={"align-middle"} dataField="portExt" visible={false} showInColumnChooser={false} />
                            <Column cssClass={"align-middle"} dataField="agentName" visible={false} showInColumnChooser={false} />
                            <ColumnChooser enabled={false} mode={"select"} allowSearch={true} />
                        </DataGrid>
                    </div>

                </div>
                <WidgetSettings showSettings={this.state.showSettings} toggleSettings={this.toggleSettings} token={this.props.token} setGroups={this.selectGroups} groups={this.state.selectedGroups} selectionType={selectionTypes.GROUPMULTIPLE}></WidgetSettings>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.agent.monitorToken,
        userId: state.agent.userId,
        extension: state.agent.extension,
        functions: state.agent.functions,
    };
};
export default compose(connect(mapStateToProps, null), withTranslation())(QueuedCalls);